import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/thumbs-up-green.svg'


const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Thumbs Up"
}, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-6 col-md-6 col-sm-6 col-xs-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerWithBackground = _resolveComponent("LoadingSpinnerWithBackground")!
  const _component_CliConfirmationTab = _resolveComponent("CliConfirmationTab")!
  const _component_AfterConfirmationAcceptanceScreen = _resolveComponent("AfterConfirmationAcceptanceScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingSpinnerWithBackground, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          (_ctx.isComprehensivePolicyType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_CliConfirmationTab, { "is-policy-referred": _ctx.isPolicyReferred }, null, 8, ["is-policy-referred"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSuperSimplePolicyType)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_AfterConfirmationAcceptanceScreen, { "insured-person-email": _ctx.insuredPersonEmail }, null, 8, ["insured-person-email"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("hr", {
      class: _normalizeClass(["hr medium-bottom-spacing", { 'd-none': _ctx.isMobileScreen }])
    }, null, 2),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn btn-booster-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAdviserHub()))
        }, "Back to home")
      ])
    ])
  ], 64))
}